export default (theme) => ({
	addButton: {
		color: '#fff',
		background: theme.palette.secondary.main,
		'&:hover': {
			background: theme.palette.secondary.dark,
		},
	},
	button: {
		margin: theme.spacing.unit,
	},
	leftIcon: {
		marginRight: theme.spacing.unit,
	},
	rightIcon: {
		marginLeft: theme.spacing.unit,
	},
	iconSmall: {
		fontSize: 20,
	},
	floatingActionButton: {
		position: 'fixed',
		bottom: '23px',
		right: '23px',
		color: '#fff',
	},
	mobilePadding: {
		[theme.breakpoints.down('xs')]: {
			padding: '12px',
		},
	},
	// tasksMobileWidth: {
	//   [theme.breakpoints.down('sm')]: {
	//     width: '100vw',
	//   },
	// },
	tasksPageGridMobileWidth: {
		[theme.breakpoints.down('xs')]: {
			marginTop: 0,
			// width: 'calc(100% - 16px)',
		},
		[theme.breakpoints.up('sm')]: {
			marginTop: 5,
			// width: 'calc(100% - 119px)',
		},
		// [theme.breakpoints.up('md')]: {
		//   width: '100%',
		// },
	},
	widthAndHeight: {
		padding: '0 10px',
		// [theme.breakpoints.down('md')]: {
		// 	padding: '0 50px',
		// },
	},
})
